var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zM71.846 200.344 0 240.259v15.737l100.174-55.652z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zM184.154 140.982 256 101.067V85.33l-100.174 55.652z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/PN.25a1c109.svg";
export { ForwardRef as ReactComponent };